module.exports = __webpack_public_path__ + "static/Hummingbird-2b4ce5bf828742a25a3bbb8d960d94fe.jpg";